/**
 * Created by JIocb on 26.05.2017.
 */
namespace Factive.Game
{
    import Signal = Factive.Core.Signal.Signal;
    import Graphics = PIXI.Graphics;
    import Slot = dragonBones.Slot;
    import Armature = dragonBones.Armature;
    import DisplayObject = PIXI.DisplayObject;
    export class UserBagView {

        private static FACE_POINTS_ARMATURES_NAMES:Array<string> = ["DicePointsOne", "DicePointsTwo", "DicePointsThree", "DicePointsFour", "DicePointsFive", "DicePointsSix"];
        private static FACE_POINTS_COLORES:Array<number> = [parseInt("D72854",16), parseInt("D72854",16), parseInt("963EC2",16), parseInt("1FAECE",16), parseInt("25983D",16), parseInt("EC912F",16)];

        private _view:dragonBones.Slot;
        private _diceViews:Array<dragonBones.Slot> = [];
        public signal: Signal = new Signal();
        private _model: Factive.Game.UserBagModel;
        private _dicePointsFaceArmaturesPool: Array<any>;

        public constructor(view:dragonBones.Slot,model:UserBagModel)
        {
            this._view = view;
            this._model = model;
            this.build();
            this._model.signal.add(this.handleUpdate,this);
            this.update();
        }

        private handleUpdate(evt:string):void
        {
            this.update();
        };

        private build() {
            var l: number = 5;
            for (var i: number = 0; i < l; i++)
            {
                this._diceViews[i] = this._view.childArmature.getSlot("cube" + i);
                this._diceViews[i].display.visible = false;
            }
            this._dicePointsFaceArmaturesPool = [];

        };

        private returnDicePointsFaceToPool(armature:Armature):void
        {
            if(armature == null || armature == undefined) return;

            var value:number = armature["diceValue"];
            if(value == undefined) return;

            var name:string = UserBagView.FACE_POINTS_ARMATURES_NAMES[value-1];

            this._dicePointsFaceArmaturesPool[name] = this._dicePointsFaceArmaturesPool[name] || [];
            this._dicePointsFaceArmaturesPool[name][this._dicePointsFaceArmaturesPool[name].length] = armature;
        };

        private getDicePointsFaceFromPool(dice:DiceData):Armature
        {
            var value:number = dice.value;
            var color:number = dice.color;

            var name:string = UserBagView.FACE_POINTS_ARMATURES_NAMES[value-1];

            var armature:Armature;

            if(this._dicePointsFaceArmaturesPool[name] == null || this._dicePointsFaceArmaturesPool[name] == undefined || this._dicePointsFaceArmaturesPool[name].length == 0)
            {
                armature =  dragonBones.PixiFactory.factory.buildArmature(name);
                armature["diceValue"] = value;
            }
            else
            {
                armature = this._dicePointsFaceArmaturesPool[name];
            }

            var clr:number = UserBagView.FACE_POINTS_COLORES[color];
            this.colorizeDicePointsFaceArmature(armature,clr);

            return armature;
        };

        private colorizeDicePointsFaceArmature(armature:dragonBones.Armature,color:number):void
        {
            var num:number = 6;
            for(var i:number = 0; i< num; i++)
            {
                var slotName:string = "DicePoint"+i.toString();
                var slot:Slot = armature.getSlot(slotName);
                if(slot==null || slot==undefined)
                {
                    return;
                }
                else
                {
                    slot.childArmature.getSlot("cercle_white").display.tint = color;
                }
            }
        }

        public handlePressOnDice(evt)
        {
            var index = evt.currentTarget.index;
            var dice:DiceData = this._model.removeFromBagBySlotIndex(index)
            this.signal.dispatch("press_on_dice",{dice:dice});
        }

        private update():void
        {
            var bag:Array<DiceData> = this._model.getBag();
            var l:number = 5;

            for(var slot:number = 0; slot < l; slot++)
            {
                var sprite = this._diceViews[slot].display;

                if(bag[slot]!=null && bag[slot]!=undefined)
                {
                    var dice = bag[slot];

                    var pointsFace:Armature = this.getDicePointsFaceFromPool(dice);
                    this._diceViews[slot].childArmature.getSlot("value").display = pointsFace;
                    this._diceViews[slot].display.visible = true;
                    sprite.visible = true;

                    if(this._model.isLocked == false)
                    {
                        sprite.interactive = true;
                        sprite.buttonMode = true;
                        sprite.index = slot;
                        sprite.off("pointerup", this.handlePressOnDice, this)
                        sprite.on("pointerup", this.handlePressOnDice, this)
                    }
                    else
                    {
                        sprite.interactive = false;
                        sprite.buttonMode = false;
                        sprite.index = -1;
                        sprite.off("pointerup", this.handlePressOnDice, this)
                    }
                }
                else
                {
                    sprite.visible = false;
                    sprite.interactive = false;
                    sprite.buttonMode = false;
                    sprite.index = -1;
                    sprite.off("pointerup", this.handlePressOnDice, this);

                    this.returnDicePointsFaceToPool(this._diceViews[slot].childArmature.getSlot("value").display);
                    this._diceViews[slot].childArmature.getSlot("value").display = null;
                }
            }
        }

        public destroy():void
        {
            this._model.signal.remove(this.handleUpdate,this);

            this.signal.removeAll();
            this.signal = null;
            this._model = null;

            for(var slot:number = 0; slot < 5; slot++) {
                var sprite = this._diceViews[slot].display;
                sprite.visible = false;
                sprite.interactive = false;
                sprite.buttonMode = false;
                sprite.index = -1;
                sprite.off("pointerup", this.handlePressOnDice, this)
            }
            this._dicePointsFaceArmaturesPool = null;
            this._diceViews = null;
            this._view = null;
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/View/UserBagView.ts